<app-modal
  [icone]="'building_02'"
  (closeModal)="toggleModal()"
  [isOpen]="this.modalTenentService.mostrarModal()"
  [size]="'md'">
  <app-modal-header>Selecionar Empresa</app-modal-header>
  <ng-container modalBody>
    <div class="py-2">
      <div class="mb-2 flex w-full items-center">
        <app-input-busca class="w-full" placeholder="Buscar empresa..." (buscar)="filtrarTenants($event)" />
      </div>
      <div class="max-h-[300px] overflow-y-auto rounded-lg border border-gray-100">
        @if (tenantsLoading$ | async) {
        <div class="flex items-center justify-center p-4">
          <div class="border-t-brand-500 h-5 w-5 animate-spin rounded-full border-2 border-gray-300"></div>
          <span class="ml-2 text-sm text-gray-500">Carregando tenants...</span>
        </div>
        } @else { @if (tenantsFiltrados$ | async; as tenants) { @if (tenants.length > 0) {
        <div class="divide grid grid-cols-1 divide-y">
          @let usuarioAtual = usuarioLogado$ | async;
          @for (tenant of tenants; track tenant.id) {
          <ng-container>
            <div
              (click)="selecionarTenant(tenant.id)"
              class="group flex w-full cursor-pointer items-center justify-between gap-2 p-2 text-left hover:bg-gray-100"
            >
              <div class="flex items-center gap-2">
                <app-logo-empresa
                  tamanho="sm"
                  [daEmpresaAtual]="tenant.nome === usuarioAtual?.tenant"
                  [nome]="tenant.nome"
                  [logoAnexoId]="tenant.logoAnexoId"
                  [logoUrl]="tenant.logoUrl"
                />
                <span class="text-sm font-medium text-content-secondary">
                  {{ tenant.nome.toUpperCase() }}
                </span>
              </div>
              @if (isTenantAtual(tenant.nome) | async; as isAtual) {
              <app-icon class="flex h-6 w-6 items-center justify-center rounded-full text-color-brand"
                size="20"
                name="checkmark_badge_01"
               />
              } @else {
              <app-icon size="20px" name="arrow_right" class="text-content-tertiary" />
              }
            </div>
          </ng-container>
          }
        </div>
        } @else {
        <div class="flex flex-col items-center justify-center p-6 text-center">
          <app-icon name="search" class="mb-2 text-2xl text-gray-400" />
          <p class="text-sm text-gray-500">Nenhum resultado encontrado.</p>
        </div>
        } } }
      </div>
    </div>
  </ng-container>
</app-modal>
